import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=510a8282&scoped=true"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"
import style0 from "./Donate.vue?vue&type=style&index=0&id=510a8282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a8282",
  null
  
)

export default component.exports